"use strict";

exports.__esModule = true;
exports.getEtagHash = exports.URLSafeBase64Encode = exports.wcsUpload = undefined;

var _util = require("./util");

var _uploadChunk = require("./uploadChunk");

var _uploadDirect = require("./uploadDirect");

var _etagUtil = require("./etagUtil");

function wcsUpload(file, token, uploadUrl, extraConfig, handlers) {
    var config = {
        file: file,
        token: token,
        uploadUrl: uploadUrl
    };

    if (!file) {
        console.log("没有文件!");
        return null;
    }

    if (file.size > _uploadChunk.BLOCK_SIZE) {
        return new _uploadChunk.UploadChunk(config, extraConfig, handlers);
    }

    return new _uploadDirect.UploadDirect(config, extraConfig, handlers);
}

function getEtagHash(file, callback) {
    if (!file) {
        console.log("没有文件!");
        callback("");
    }
    var promise = (0, _etagUtil.getEtag)(file);
    promise.then(function (etagHash) {
        callback(etagHash);
    });
}

exports.wcsUpload = wcsUpload;
exports.URLSafeBase64Encode = _util.URLSafeBase64Encode;
exports.getEtagHash = getEtagHash;


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 151
// module chunks = 0